import type { EPinsUpdateTrigger } from './constants';

export interface IPendingPinsUpdate {
  trigger: EPinsUpdateTrigger;
  startedAt: number;
  /**
   * Пины перерисовываются и сами по себе — при панорамировании, анимации пульсации.
   * Замер завершаем только после того, как приехали новые кластеры,
   * иначе засчитаем чужую перерисовку и получим неправдоподобно быстрый SLI.
   */
  isDataReady: boolean;
}

/**
 * Замер живёт между разными модулями: старт ставят подписка на события карты и применение
 * фильтров, середину отмечает экшен загрузки кластеров, финиш — слой пинов.
 * Поэтому состояние модульное, а не в экземпляре фасада.
 */
let pendingUpdate: IPendingPinsUpdate | null = null;

/** Новое взаимодействие отменяет предыдущий незавершённый замер: пользователь уже передумал */
export function startPendingPinsUpdate(trigger: EPinsUpdateTrigger, startedAt: number) {
  pendingUpdate = { trigger, startedAt, isDataReady: false };
}

export function markPendingPinsUpdateDataReady() {
  if (pendingUpdate) {
    pendingUpdate.isDataReady = true;
  }
}

export function getPendingPinsUpdate(): IPendingPinsUpdate | null {
  return pendingUpdate;
}

export function clearPendingPinsUpdate() {
  pendingUpdate = null;
}
